import { OAuth2Service, WAuth2Service } from '@creditornot/wolt-auth';

export const oAuth2Service = new OAuth2Service({
  clientId: 'delivery-os-web',
  loginRedirectUri: `${import.meta.env.VITE_DELIVERY_OS_GATEWAY_URI}/oauth2/callback`,
  logoutRedirectUri: `${import.meta.env.VITE_DELIVERY_OS_GATEWAY_URI}/oauth2/logout-callback`,
  serviceUrl: import.meta.env.VITE_AUTH_API_URI,
});

export const wAuth2Service = new WAuth2Service({ serviceUrl: import.meta.env.VITE_AUTH_API_URI });
